export const SUBSCRIPTION_TYPES = Object.freeze({
  ANNUAL: {
    id: 'annual',
    label: 'Annual Subscription',
    description: 'Healthgrades Elevated Profile',
    price: 479.4,
    displayPrice: '$479.40',
    priceLabel: '$479.40/year',
    billingCycle: 'yearly',
    planCode: {
      provider: 'elevated_profile_yearly', // One-to-one subscription
      admin: 'HGGRPA-ELEVATED', // Group subscription (roster)
    },
  },
  MONTHLY: {
    id: 'monthly',
    label: 'Monthly Subscription',
    description: 'Healthgrades Elevated Profile',
    price: 49.95,
    displayPrice: '$49.95',
    priceLabel: '$49.95/month',
    billingCycle: 'monthly',
    planCode: {
      provider: 'elevated_profile_monthly', // One-to-one subscription
      admin: 'HGGRPM-ELEVATED', // Group subscription (roster)
    },
  },
});

// Maximum total providers allowed for self-serve eligibility. Practices with 101+ providers must contact support
export const MAX_PROVIDERS_LIMIT = 100;

// Maximum providers allowed per checkout session
export const MAX_PROVIDERS_PER_SESSION = 25;

/**
 * Generates error message when session limit is exceeded
 * @param {number} currentCount - Current number of providers in roster
 * @returns {string} Error message
 */
export const getSessionLimitExceededMessage = (currentCount) => {
  const excessCount = currentCount - MAX_PROVIDERS_PER_SESSION;
  return `You can purchase up to ${MAX_PROVIDERS_PER_SESSION} providers per checkout session. Please remove ${excessCount} provider(s) to continue.`;
};
